import React from 'react';

function Conditions() {
    return (
        <div className="Conditions">
            <div className="card shadows logo">
                <img src="../assets/img/logo.png" className="card-img-top p-3 pb-0" alt="Logo" />
                <div className="card-body pt-0">
                    <h4 className="card-title text-center">เงื่อนไขการให้บริการ</h4>
                    <p className="card-text text-center">
                        จอดฟรี 15 นาทีแรก<br />
                        หลังจาก 15 นาที คิดชั่วโมงละ 50 บาท<br />
                        อัตราค่าบริการจอดรถอาจมีการเปลี่ยนแปลง<br />
                        ได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
                    </p>
                    <p className="text-center" style={{ fontSize: 'large' }}>*** บัตรหายปรับ 200 บาท ***</p>
                    <p className="text-center" style={{ fontSize: 'small' }}>เศษของชั่วโมงคิดเป็นเต็มชั่วโมง</p>
                </div>
            </div>

            <div style={{ width: '100%' }}>
                <p className="text-center">Version 1.0.0</p>
                <p className="text-center">© 2023 AccessLink Innovation Co., Ltd.</p>
            </div>
        </div>
    );
}

export default Conditions;
